<app-spinner-page *ngIf="isLoading"></app-spinner-page>
<div fxLayout="column" class="container">
    <div fxLayout="row wrap">
        <div *ngIf="product.baseImageUrl !== null" class="image gallery-wrapper" fxFlex="60%" fxFlex.lt-sm="100%"
            fxLayout="row" fxLayoutAlign="center center">
            <gallery [thumbHeight]="120" [loop]="false" [thumb]="images.length > 1" [loadingStrategy]="'preload'"
                [counter]="false" class="image-gallery" [items]="images" [dots]="true"></gallery>
        </div>
        <div *ngIf="product.baseImageUrl === null" class="product-thumbnail" class="image" fxFlex="50%"
            fxFlex.lt-sm="100%" [style.background-image]="'url(./assets/images/placeholder.png)'">
        </div>
        <div class="details" fxFlex="40%" fxFlex.lt-sm="100%">
            <div fxLayout="row wrap">

                <div class="name" fxFlex="55%" fxFlex.lt-md="100%">
                    <div class="back-to-catalogue">
                        <a routerLink="/products">
                            <mat-icon>keyboard_arrow_left</mat-icon>
                            <span i18n="@@product-page_back-to-catalogue">Back To Catalog</span>
                        </a>
                    </div>
                    <h2 *ngIf="product.decor">{{product.decor?.label}}</h2>
                    <h2 *ngIf="!product.decor">{{decorDefaultName}}</h2>
                    <h1>{{product.name}}</h1>
                    <h1>{{product.price | currency : this.storeService.getStoreCurrency()}}<span class="special-info">*</span></h1>
                </div>
            </div>
            <div class="quote">
                <select name="qty" class="qty-select" (change)="changeQuantityOption($event.target.value)"
                    *ngIf="(activateFreeText$ | async) === false">
                    <option *ngFor="let number of qtySelectionOptions" [value]="number">{{number}}</option>
                </select>
                <input (change)='changeQuantityOption($event.target.value)' type="number" class="qty-select qty-input" *ngIf="activateFreeText$ | async" value="8" min="1"
                    max="999" />
                <button class="btn-primary add-to-quote-btn" (click)="openAddToQuoteDialog()" mat-button
                    i18n="@@product-page_add-to-quote-button">Add to quote
                </button>

            </div>

            <div class="product-description">
                <p i18n="@@product-detail_description">DESCRIPTION</p>
                <span class="special-info">Art. {{product.sku}}</span>
                <div class="description">
                    <p>{{product.description}}</p>
                </div>
            </div>
            <div>
                <mat-accordion>
                    <mat-expansion-panel (opened)="openDetailText()" (closed)="closeDetailText()"
                        hideToggle >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span>{{(getIsDetailTextOpen$ | async) ? '- ' : '+ '}}</span> &nbsp; <span i18n="@@product-detail_details">PRODUCT DETAILS</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="attributes" fxLayout="row wrap" *ngIf="product.measurementsMetric != null">
                            <div class="code" fxFlex="40%" fxFlex.lt-md="50%"
                                i18n="@@product-page_attribute-measurements-metric">Measurements in mm:
                            </div>
                            <div class="value" fxFlex="60%" fxFlex.lt-md="40%">{{product.measurementsMetric.label}}
                            </div>
                        </div>
                        <div class="attributes" fxLayout="row wrap" *ngIf="product.measurementsImperial != null">
                            <div class="code" fxFlex="40%" fxFlex.lt-md="50%"
                                i18n="@@product-page_attribute-measurements-imperial">Measurements in inches:
                            </div>
                            <div class="value" fxFlex="60%" fxFlex.lt-md="40%">
                                {{product.measurementsImperial.label}}
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
                <mat-accordion>
                    <mat-expansion-panel (opened)="openSafetyText()" (closed)="closeSafetyText()" hideToggle
                        class="safetyExtensionPanel">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                               <span>{{(getIsSafetyTextOpen$ | async) ? '- ' : '+ '}}</span> &nbsp; <span i18n="@@product-detail_safety">SAFETY</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="attributes" fxLayout="row wrap" *ngIf="product.microwaveSafe != null">
                            <div class="code" fxFlex="40%" fxFlex.lt-md="50%"
                                i18n="@@product-page_attribute-microwave-safe">Microwave-safe:
                            </div>
                            <div class="value" fxFlex="60%" fxFlex.lt-md="40%">{{product.microwaveSafe.label}}</div>
                        </div>
                        <div class="attributes" fxLayout="row wrap" *ngIf="product.dishwasherSafe != null">
                            <div class="code" fxFlex="40%" fxFlex.lt-md="50%"
                                i18n="@@product-page_attribute-dishwasher-safe">Dishwasher-safe:
                            </div>
                            <div class="value" fxFlex="60%" fxFlex.lt-md="40%">{{product.dishwasherSafe.label}}
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <br />
            <span class="special-info">{{this.priceHintService.getPriceHint()}}</span>
        </div>
    </div>
</div>
